import { Injectable } from "@angular/core";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { ConsentCookie, UpdateConsentPayload, UserConsent } from "./cookie-consent.model";

const ACTION_PREFIX = "[Cookie Consent]";
export const COOKIE_CONSENT_ACTION_TYPE = {
	set: `${ACTION_PREFIX} Set ${SYNC_SUFFIX}`,
	setEnabled: `${ACTION_PREFIX} Set Enabled ${SYNC_SUFFIX}`,
	update: `${ACTION_PREFIX} Update ${SYNC_SUFFIX}`,
	updateSuccess: `${ACTION_PREFIX} Update Success ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class CookieConsentAction {
	/**
	 * @internal
	 * Sets the `isAccepted` and `isConsentGiven` values in the store. Does NOT write to the cookie
	 */
	set(isAccepted: boolean | undefined): ActionWithPayload {
		return {
			type: COOKIE_CONSENT_ACTION_TYPE.set,
			payload: isAccepted,
		};
	}

	/**
	 * Updates the cookie consent properties to the cookie
	 */
	update(consentProperties: UserConsent, shouldSendGTM = true): ActionWithPayload<UpdateConsentPayload> {
		return {
			type: COOKIE_CONSENT_ACTION_TYPE.update,
			payload: { consentProperties, shouldSendGTM },
		};
	}

	/**
	 * Updates the cookie consent properties to the store
	 */
	updateSuccess(consentProperties: ConsentCookie): ActionWithPayload<ConsentCookie> {
		return {
			type: COOKIE_CONSENT_ACTION_TYPE.updateSuccess,
			payload: consentProperties,
		};
	}

	/**
	 * @internal
	 * Sets the `isEnabled` value in the store
	 */
	setEnabled(isEnabled: boolean): ActionWithPayload {
		return {
			type: COOKIE_CONSENT_ACTION_TYPE.setEnabled,
			payload: isEnabled,
		};
	}
}
